<template>
    <div id="listPurchaseOrderList">
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name"><div class="page-title"> Purchase Order List</div></div>
                <div class="container-fluid">




                    <div class="admin-page-content asset-purchase-order">
                        <div class="btn-groups badge-buttons text-left mb-3">
                            <div id="divTabMenu" class="btn-group rental-btn-grup-left" role="group" aria-label="Basic example">
                                <button type="button" id="getvendorPurchaseOrder" v-on:click="getOpenPurchaseOrder(this)" :class="'btn btn-secondary '+vendorPurchase"> Open </button>
                                <button type="button" id="getcustomerPurchaseOrder" v-on:click="getClosePurchaseOrder(this)" :class="'btn btn-secondary '+customerPurchase"> Closed </button>
                            </div>
                            <!-- <div class="mobile-action-btn">
                                <select class="selectpicker">
                                    <optgroup>
                                        <option><button type="button" id="getvendorPurchaseOrder" v-on:click="getVendorPurchaseOrder(this)" :class="'btn btn-secondary '+vendorPurchase"> Vendor <span>  {{purchaseOrderCount}}</span> </button></option>
                                        <option><button type="button" id="getcustomerPurchaseOrder" v-on:click="getCustomerPurchaseOrder(this)" :class="'btn btn-secondary '+customerPurchase"> Customer <span> {{customerpurchaseOrderCount}}</span> </button></option>
                                    </optgroup>
                                </select>
                            </div> -->
                        </div>
                        <vendor-purchase-order v-if="selectedStatus =='open'" id="purchaseorder" :moduleN="aPurchaseOrder" :vendorPurchaseVal="purchaseOrder" :vendorPurchaseStatus="selectedStatus"></vendor-purchase-order>
                        <vendor-purchase-order v-if="selectedStatus =='close'" id="purchaseorder" :moduleN="aPurchaseOrder" :vendorPurchaseVal="purchaseOrder" :vendorPurchaseStatus="selectedStatus"></vendor-purchase-order>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="col-md-12">
                    <div class="error-template">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>

<script>
    import Vue from "vue";
    import EventBus from "./../event-bus";
    import {commonMixins} from '../../mixins/commonMixins';
    
    
    import VendorPurchaseOrderList from '@/components/VendorPurchaseOrderList';
    Vue.component("vendor-purchase-order", VendorPurchaseOrderList);
    var contex

    export default {
        name: "AssetPurchaseOrderList",
        mixins:[commonMixins],
        data: () => ({
            aPurchaseOrder:"aPurchaseOrder",
            status:[],
            cantAccessPage:'',
            permissions:[],
            loading: false,
            vendorPurchaseOrder:true,
            customerPurchaseOrder:false,
            purchaseOrder:'assetVendorPO',
            customerpurchaseOrder:'custPo',
            vendorPurchase:'',
            customerPurchase:'',
            purchaseOrderCount:0,
            customerpurchaseOrderCount:0,
            selectedStatus: "",
            pageKey:"_vendor_po_list_",
        }),

        watch:{
            permissions: function(permission){
                var self = this;
                permission.forEach(function (permissions) {
                    if(permissions.name == 'list_purchase_order') {
                        self.cantAccessPage = true;
                    }

                });
                if(self.cantAccessPage == ''){
                    self.cantAccessPage = false;
                }
            },
        },

        beforeMount: function() {
            contex = this;
        },

        mounted: function () {

            var self = this;
            // EventBus.$emit("profile", false);

            self.getPermissions();

            $('#divTabMenu button').removeClass("active");
            var prevSelectedTab = localStorage.getItem("purchase_list_prev_tab");
            
            if ( prevSelectedTab == null ) {
                self.selectedStatus = "open";
                self.vendorPurchase = 'active';
                localStorage.setItem('purchase_list_prev_tab', 'open_tab');

            } else {
                if ( prevSelectedTab == 'close_tab' ) {
                    self.selectedStatus = "close";
                    self.customerPurchase = 'active';

                } else {                    
                    self.selectedStatus = "open";
                    self.vendorPurchase = 'active';
                }
            }
            // if(self.selectedStatus == null){
            //     setTimeout(function() {

            //         self.vendorPurchase = 'active';
            //         self.customerPurchaseOrder = false;
            //         self.selectedStatus = "open";

            //     }, 1000);
            // }
            
        },

        methods: {

          getOpenPurchaseOrder: function(){

                var self = this;
                $('#divTabMenu button').removeClass("active");
                $("#getvendorPurchaseOrder").addClass("active");
                localStorage.setItem('purchase_list_prev_tab', 'open_tab');
                self.selectedStatus = "";
                self.$nextTick(() => {
                  // Add the component back in
                  self.selectedStatus = "open";
                });
                // self.vendorPurchaseOrder = true;
                // self.title = "Vendor Purchase Order List";
            },
            getClosePurchaseOrder: function(){

                var self = this;
                $('#divTabMenu button').removeClass("active");
                $("#getcustomerPurchaseOrder").addClass("active");
                localStorage.setItem('purchase_list_prev_tab', 'close_tab');
                self.selectedStatus = "";
                self.$nextTick(() => {
                  // Add the component back in
                  self.selectedStatus = "close";
                  console.log(self.selectedStatus);
                });

                // self.customerPurchaseOrder = true;
                // self.vendorPurchaseOrder = false;
                // self.title = "Customer Purchase Order List";
            },


        }
    };

</script>




// WEBPACK FOOTER //
// src/components/asset/AssetPurchaseOrderList.vue